<template>
  <CommonFiftyFiftyTeaserWithBullets
    :image="image"
    :body="body"
    :cta="cta"
    :alt="alt"
    :routine="routineEntry"
    :heading="routineEntry ? routineEntry.title : ''"
    :block-position="blockPosition"
  >
    <div v-if="routineEntry">
      <h3 class="fluid-3xl leading-tightest">{{ routineEntry.title }}</h3>
      <RoutineFeatures
        :duration="routineDuration"
        :exercise-count="routineExerciseCount"
        :difficulty="routineDifficulty"
        class="mt-4"
      />
    </div>
  </CommonFiftyFiftyTeaserWithBullets>
</template>

<script>
import Routine from '@/mixins/Routine';
import CommonFiftyFiftyTeaserWithBullets from '@/components/common/blocks/FiftyFiftyTeaserWithBullets';
import RoutineFeatures from '@/components/exercises/RoutineFeatures';

export default {
  components: {
    CommonFiftyFiftyTeaserWithBullets,
    RoutineFeatures,
  },
  mixins: [Routine],
  props: {
    routine: {
      type: Array,
      default: () => [],
    },
    image: {
      type: Array,
      default: () => [],
    },
    alt: {
      type: String,
      default: null,
    },
    body: {
      type: String,
      default: '',
    },
    ctaText: {
      type: String,
      default: null,
    },
    blockPosition: {
      type: Number,
      default: 0,
    },
  },
  computed: {
    /**
     * overwrite Routine-Mixin prop bindings to current props
     */
    routineEntry() {
      return this.routine ? this.routine[0] : null;
    },
    cta() {
      return {
        text: this.ctaText,
        to: { path: this.$localeRootPath(this.routineEntry?.uri) },
      };
    },
  },
};
</script>
